import { AvailableToAcceptBounty_ValidationCode } from '../../../generated/backendGraphql'

export const acceptValidationCodeToReason = (
  code?: AvailableToAcceptBounty_ValidationCode,
) => {
  if (!code) return 'An unknown error occurred.'

  switch (code) {
    case 'C_LEVEL_ACCEPT_LIMIT_REACHED':
      return 'Sorry you are only allowed to do one bounty for this store'
    case 'PRODUCT_DISABLED':
      return 'The store has disabled this product in Bounty'
    case 'STORE_SUBSCRIPTION_INACTIVE':
      return 'The store has deactivated their Bounty subscription'
    case 'STORE_SNIPPETS_DISABLED':
      return 'The store has disabled Bounty temporarily'
    case 'STORE_TIKTOK_USERNAME_NOT_SET':
      return 'The store has not set their TikTok username'
    /*
      these 2 are actually handled in other places
      before you would even get to show this,
      but I'm putting them here to be exhaustive
    */
    case 'ORDER_NOT_DELIVERED':
      return 'Your order is not delivered yet'
    case 'ACCEPT_WINDOW_EXPIRED':
      return 'Your bounty has expired'
    case 'STORE_OVER_MONTHLY_SPEND_BUDGET':
      return 'The store is over budget this month, check back soon'
    case 'CREATOR_OVER_STORE_POST_LIMIT':
      return 'You cannot accept this Bounty right now. Check back at the beginning of next month.'
    case 'CREATOR_BLOCKED_BY_STORE':
      return 'You cannot accept Bounties for this store. Please reach out to support for more information.'
    case 'ORDER_HAS_NO_ENABLED_PRODUCTS':
      return 'You cannot accept this Bounty because the products are no longer eligible for Bounty.'
    case 'ORDER_NOT_FOUND':
    case 'SERVER_ERROR':
    case 'BOUNTY_NOT_PENDING_STATE':
    case 'UNKNOWN_STORE_FOR_BOUNTY':
    case 'NO_USER_ASSOCIATED_TO_ORDER':
      return 'An unknown error occurred.'
    case 'VALID':
      return ''

    default:
      // CI fails this on throw for some reason
      // https://github.com/bounty-app/platform/actions/runs/4396547378/jobs/7702268387
      return 'An unknown error occurred.'
  }
}
